import './home.scss';

import React from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router';

import { useAppSelector } from 'app/config/store';

export const Home = () => {
  const account = useAppSelector(state => state.authentication.account);

  return (
    <Row>
      <Col md="12">
        <h1 className="display-4">¡Bienvenido!</h1>
        {account?.login ? (
          <div>
            <Alert variant="success">{`Está conectado como "${account.login}".`}</Alert>
          </div>
        ) : (
          <div>
            <Alert variant="warning">
              <Link to="/login" className="alert-link">
                iniciar sesión
              </Link>
            </Alert>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default Home;
